import { SearchIcon } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { SegmentedControl } from '@/components/forms/segmented-control'
import type { StatusFilter } from '@/lib/status-filter'

/** Search box and Active / Inactive / All switch above the management tables. */
export function ListToolbar({
  search,
  onSearchChange,
  searchPlaceholder,
  status,
  onStatusChange
}: {
  search: string
  onSearchChange(value: string): void
  searchPlaceholder: string
  status: StatusFilter
  onStatusChange(value: StatusFilter): void
}): React.JSX.Element {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative w-full max-w-72">
        <SearchIcon
          aria-hidden="true"
          className="pointer-events-none absolute top-1/2 left-2.5 size-4 -translate-y-1/2 text-muted-foreground"
        />
        <Input
          type="search"
          aria-label={searchPlaceholder}
          placeholder={searchPlaceholder}
          className="pl-8"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>
      <SegmentedControl
        ariaLabel="Status"
        value={status}
        onChange={onStatusChange}
        options={[
          { value: 'active', label: 'Active' },
          { value: 'inactive', label: 'Inactive' },
          { value: 'all', label: 'All' }
        ]}
      />
    </div>
  )
}
